import React from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import CustomTooltip from './CustomTooltip/CustomTooltip';

import { upFirstLetter } from 'utils/common';
import { colorsNew } from 'components/common/charts/helpers/config';

const Chart = ({ chartData }) => {
  const sysNames = Object.keys(chartData);
  const inf = [];

  const formatterY = value => (value ? `${value}%` : 0);
  const formatterX = value => (value && value !== 'auto' ? value : '');

  sysNames.map((item, ind) => {
    inf.push({ name: upFirstLetter(item) });

    chartData[item].map(ver => {
      const title = ver.appVersion;
      inf[ind][title] = ver.userPercent;
      return false;
    });
    return false;
  });

  let arr = [];
  let arrColor = [];
  inf.map(bar => {
    const keys = Object.keys(bar);
    keys.splice(keys.indexOf('name'), 1);

    for (let i = 0; i < keys.length; i += 1) {
      let temp = i % 10;
      arrColor.push(colorsNew[temp]);
    }
    arr = [...arr, ...keys];
    return false;
  });

  const arrColorNew = []; // to check colors output
  sysNames.map(item => {
    for (let i = 0; i < chartData[item].length; i += 1) {
      if (i < 10) {
        arrColorNew.push(colorsNew[i]);
      } else {
        arrColorNew.push(colorsNew[i % 10]);
      }
    }
    return false;
  });

  // const unique = arr.filter((e, i, a) => a.indexOf(e) !== i);

  // unique.map(item => {
  arr.map(item => {
    const indices = [];
    const element = item;
    var idx = arr.indexOf(element);
    while (idx !== -1) {
      indices.push(idx);
      idx = arr.indexOf(element, idx + 1);
    }
    for (let i = 1; i < indices.length; i += 1) {
      arrColor.splice(indices[i], 1);
    }
    return false;
  });

  const uniq = [...new Set(arr)];

  sysNames.map((item, ind) => {
    chartData[item].map(ver => {
      const title = ver.appVersion;
      inf[ind][`${title}-count`] = ver.userCount;
      return false;
    });
    return false;
  });

  return (
    <ResponsiveContainer width="100%" height={156}>
      <BarChart
        data={inf}
        margin={{
          top: 16,
          right: 0,
          left: -24,
          bottom: 0
        }}
      >
        <CartesianGrid vertical={false} stroke="#dde6f2" />
        <XAxis
          dataKey="name"
          tick={{
            fill: '#536283',
            fontSize: '11px'
          }}
          axisLine={false}
          tickLine={false}
          minTickGap={1}
          tickFormatter={formatterX}
        />
        <YAxis
          tickCount={5}
          scale="linear"
          domain={[0, 100]}
          tick={{
            fill: '#536283',
            fontSize: '11px'
          }}
          axisLine={false}
          tickLine={false}
          minTickGap={1}
          tickFormatter={formatterY}
        />
        {uniq.length !== 0 && (
          <Tooltip content={<CustomTooltip />} wrapperStyle={{ zIndex: 100 }} />
        )}
        {uniq.map((item, ind) => (
          <Bar
            dataKey={item}
            stackId="a"
            fill={arrColorNew[ind]}
            key={item}
            hel="o"
            maxBarSize={40}
          />
        ))}
      </BarChart>
    </ResponsiveContainer>
  );
};

Chart.propTypes = {
  chartData: PropTypes.object
};

export default Chart;
